export { default } from './ProductGoodToKnow';
